module.exports = __webpack_public_path__ + "static/media/IMG_0326.d254a9e1.JPG";